module.exports = __webpack_public_path__ + "f55d395eeba98b86532aa1e9cb4c9948.svg";